<!-- <div class="py-8 lg:py-20 p-6 w-full lg:max-w-8xl space-y-12 mx-auto relative"> -->
<div class="py-8 space-y-12 p-6 md:p-12 lg:py-0 container mx-auto relative">
    <div class="grid grid-cols-12 justify-center gap-4" data-aos="fade-up"  data-aos-delay="400">
        <div class="col-span-12 md:col-span-12">
            <div class="relative text-center">
                <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink top-32 left-0 w-10 h-10" alt="">
                <h2 class="text__grey--gradient text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl mi--font-regular">Roadmap</h2>
                <p class="text-white text-center text-xl sm:text-2xl lg:text-3xl xl:text-4xl mi--font-regular absolute bottom-0 inset-x-8 lg:inset-x-20">Journey of product</p>
                <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink bottom-32 right-8 w-10 h-10" alt="">
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-4 lg:pt-16">
        <div class="col-span-12">
            <owl-carousel-o [options]="customOptions" class="roadmap-carousel">
                <ng-template carouselSlide>
                    <div class="relative" data-aos="fade-up"  data-aos-delay="500">
                        <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular inline-flex">Q2 2022</h2>
                        <div class="flex items-end gap-4 md:gap-6">
                            <h2 class="text__grey--gradient text-6xl md:text-7xl lg:text-9xl mi--font-regular">1</h2>
                           <div class="pt-2">
                            <p class="text-white text-sm md:text-xl ep--font-light !leading-[1.56rem]">Product Dev Phase 1</p>
                            <ul class="list-disc space-y-3 pt-4 pl-4">
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">Token Modules </li>
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">NFT Modules</li>
                            </ul>
                           </div>
                        </div>
                        <img src="assets/landing-new/icons/connect-line.svg" class="!hidden lg:!block lg:absolute top-2 left-14 w-full object-contain h-4" alt="">
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="relative" data-aos="fade-up"  data-aos-delay="600">
                        <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular inline-flex">Q4 2022</h2>
                        <div class="flex items-end gap-4 md:gap-6 ">
                            <h2 class="text__grey--gradient text-6xl md:text-7xl lg:text-9xl mi--font-regular">2</h2>
                            <div class="pt-2">
                                <p class="text-white text-sm md:text-xl ep--font-light !leading-[1.56rem]">Product Dev Phase 2</p>
                                <ul class="list-disc space-y-3 pt-4 pl-4">
                                    <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">DeFi Solutions</li>
                                    <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">Industry Solutions</li>
                                </ul>
                            </div>
                        </div>
                        <img src="assets/landing-new/icons/connect-line.svg" class="!hidden lg:!block lg:absolute top-2 left-14 w-full object-contain h-4" alt="">
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="relative" data-aos="fade-up"  data-aos-delay="700">
                        <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular inline-flex">Q1 2023</h2>

                        <div class="flex items-end gap-4 md:gap-6">
                            <h2 class="text__grey--gradient text-6xl md:text-7xl lg:text-9xl mi--font-regular">3</h2>
                           <div class="pt-2">
                            <p class="text-white text-sm md:text-xl ep--font-light !leading-[1.56rem]">Platform Launch</p>
                            <ul class="list-disc space-y-3 pt-4 pl-4">
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">Token Modules </li>
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">NFT Modules</li>
                            </ul>
                           </div>
                        </div>
                        <img src="assets/landing-new/icons/connect-line.svg" class="!hidden lg:!block lg:absolute top-2 left-14 w-full object-contain h-4" alt="">
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="relative" data-aos="fade-up"  data-aos-delay="700">
                        <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular inline-flex">Q1 2023</h2>
                         <div class="flex items-end gap-4 md:gap-6">
                            <h2 class="text__grey--gradient text-6xl md:text-7xl lg:text-9xl mi--font-regular">4</h2>
                           <div class="pt-2">
                            <p class="text-white text-sm md:text-xl ep--font-light !leading-[1.56rem]">Campaign Start</p>
                            <ul class="list-disc space-y-3 pt-4 pl-4">
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">Seed Raise of $11 M </li>
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">Accelerated Marketing</li>
                            </ul>
                           </div>
                        </div>

                        <img src="assets/landing-new/icons/connect-line.svg" class="!hidden lg:!block lg:absolute top-2 left-14 w-full object-contain h-4" alt="">
                    </div>
                </ng-template>

                <ng-template carouselSlide>
                    <div class="relative" data-aos="fade-up"  data-aos-delay="700">
                        <h2 class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular inline-flex">Q2 2023</h2>
                        <div class="flex items-end gap-4 md:gap-6">
                            <h2 class="text__grey--gradient text-6xl md:text-7xl lg:text-9xl mi--font-regular">5</h2>
                           <div class="pt-2">
                            <p class="text-white text-sm md:text-xl ep--font-light !leading-[1.56rem]">Gensis</p>
                            <ul class="list-disc space-y-3 pt-4 pl-4">
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">BX Token Generation Event </li>
                                <li class="text-white text-sm md:text-base ep--font-light !leading-[1.56rem]">Token Sale Launch</li>
                            </ul>
                           </div>
                        </div>
                        <img src="assets/landing-new/icons/connect-line.svg" class="!hidden lg:!block lg:absolute top-2 left-14 w-full object-contain h-4" alt="">
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
 </div>
